import type { Department } from '@/types'

/**
 * How an admin screen names a preset reason outside its section's own list:
 * "Colour mismatch (Print)". Each section keeps its own reasons, so the same
 * name can sit in several, and the section tells them apart.
 */
export function reasonLabel(name: string, section: string | null | undefined): string {
  return section ? `${name} (${section})` : name
}

/** The name of the section a reason belongs to. */
export function sectionName(departmentId: number, departments: Department[] | undefined): string | null {
  return departments?.find((dept) => dept.id === departmentId)?.name ?? null
}
